/*
 * Organic Promise homepage scripts (Jenpharm-style layout), loaded after op-theme.js.
 * Product grid paging (10 per page) and "Add to cart" on op-card product cards.
 */
(function () {
  'use strict';

  function addItems(items) {
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: items}),
    }).then(function (res) {
      if (!res.ok) throw new Error('Could not add to cart');
      return res.json();
    });
  }

  /* ---------- Product grid: 10 per page with page buttons ---------- */

  var ARROW = {
    prev: '<svg class="op-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M14.5 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg class="op-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M9.5 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  };

  function initPagers() {
    document.querySelectorAll('[data-op-pager]').forEach(function (root) {
      if (root.dataset.opReady) return;
      root.dataset.opReady = '1';
      var items = root.querySelectorAll('[data-op-page-item]');
      var nav = root.querySelector('[data-op-pager-nav]');
      var perPage = Number(root.dataset.perPage) || 10;
      var pages = Math.ceil(items.length / perPage);
      var current = 1;

      function show(page, scroll) {
        current = Math.min(Math.max(page, 1), pages);
        items.forEach(function (item, i) {
          item.hidden = Math.floor(i / perPage) + 1 !== current;
        });
        if (!nav || pages < 2) return;
        var html = '<button type="button" class="op-round-btn" data-page="' + (current - 1) + '" aria-label="Previous page"' + (current === 1 ? ' disabled' : '') + '>' + ARROW.prev + '</button>';
        for (var p = 1; p <= pages; p++) {
          html += '<button type="button" class="op-pager__num" data-page="' + p + '"' + (p === current ? ' aria-current="page"' : '') + ' aria-label="Page ' + p + '">' + p + '</button>';
        }
        html += '<button type="button" class="op-round-btn" data-page="' + (current + 1) + '" aria-label="Next page"' + (current === pages ? ' disabled' : '') + '>' + ARROW.next + '</button>';
        nav.innerHTML = html;
        nav.hidden = false;
        if (scroll && root.getBoundingClientRect().top < 0) {
          root.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
      }

      if (nav) {
        nav.addEventListener('click', function (event) {
          var button = event.target.closest('[data-page]');
          if (!button || button.disabled) return;
          show(Number(button.dataset.page), true);
        });
      }
      show(1, false);
    });
  }

  /* ---------- "Add to cart" on product cards ---------- */

  function refreshCartBubble() {
    return fetch('/?sections=cart-icon-bubble')
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !sections['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var fresh = doc.querySelector('.shopify-section');
        bubble.innerHTML = fresh ? fresh.innerHTML : bubble.innerHTML;
      })
      .catch(function () {});
  }

  function initQuickAdd() {
    if (document.documentElement.dataset.opQuickAddReady) return;
    document.documentElement.dataset.opQuickAddReady = '1';
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-op-quick-add]');
      if (!button || button.disabled) return;
      var label = button.querySelector('span');
      var original = label ? label.textContent : '';
      button.disabled = true;
      if (label) label.textContent = 'Adding…';
      addItems([{id: Number(button.dataset.opQuickAdd), quantity: 1}])
        .then(function () {
          if (label) label.textContent = 'Added ✓';
          button.classList.add('is-added');
          return refreshCartBubble();
        })
        .catch(function () {
          if (label) label.textContent = 'Try again';
        })
        .then(function () {
          setTimeout(function () {
            button.disabled = false;
            button.classList.remove('is-added');
            if (label) label.textContent = original;
          }, 1800);
        });
    });
  }

  function init() {
    initPagers();
    initQuickAdd();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-run when sections are edited in the theme editor.
  document.addEventListener('shopify:section:load', initPagers);
})();
